module.exports = __webpack_public_path__ + "media/images/nmx-30adf8510e9758babc54b9fb981c94be.png";